module.exports = __webpack_public_path__ + "img/mariage-2.5a6b147b.jpg";